import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject, Renderer2 } from '@angular/core';
import { isPlatformBrowser, isPlatformServer, DOCUMENT } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../../_services/langhfre.service';
import { environment } from 'src/environments/environment';
//declare function ire(string,{}): any;
@Component({
  selector: 'app-plagiarism-checker',
  templateUrl: './plagiarism-checker.component.html',
  styleUrls: ['./plagiarism-checker.component.scss']
})
export class PlagiarismCheckerComponent implements OnInit, AfterViewInit {
  video_pause: boolean = false;
  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private _renderer2: Renderer2, 
    @Inject(DOCUMENT) private _document: Document,
    private LinkService: LinkService
  ) { 
    this.document.body.classList.add('nosnipptFooter');
  }

  ngOnInit(): void {
    this.titleService.setTitle('Plagiarism Checker | Leading Plagiarism Detection | Trinka AI');
    this.metaTagService.updateTag({ name: 'description', content: "Prevent unintentional plagiarism with market leading plagiarism detection, trusted by 1700+ Publishers Worldwide. Get Free Score now!" });
    this.metaTagService.updateTag({ property: 'og:title', content: 'Plagiarism Checker | Leading Plagiarism Detection | Trinka AI' });
    this.metaTagService.updateTag({ property: 'og:description', content: 'Prevent unintentional plagiarism with market leading plagiarism detection, trusted by 1700+ Publishers Worldwide. Get Free Score now!' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/features/plagiarism-check' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/features/pc-check.webp' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: 'Plagiarism Checker | Leading Plagiarism Detection | Trinka AI' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "Prevent unintentional plagiarism with market leading plagiarism detection, trusted by 1700+ Publishers Worldwide. Get Free Score now!" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/features/pc-check.webp' });
    this.metaTagService.updateTag({ name: 'keywords', content: 'plagiarism checker, verify plagiarism, find out plagiarism, free plagiarism checker online free, plagiarism finder free, plagiarism search free, verify plagiarism free, plagiarism remover, plagiarism tool online, find plagiarism online, free plagiarism software for students, check plagiarism checker, online plagiarism checker online, verify plagiarism online, plagiarism detector' });
    this.metaTagService.updateTag({ name: 'language', content: 'en-us' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/plagiarism-check' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features/plagiarism-check' });
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
    {"@context":"https://schema.org","@graph":[{"@type":"Product","name":"Plagiarism Checker","image":"https://www.trinka.ai/assets/images/plagiarism-check/plagiarism-check-graph.jpg","description":"Prevent unintentional plagiarism with market leading plagiarism detection, trusted by 1700 Publishers Worldwide. Get Free Score now!","brand":{"@type":"Brand","name":"Trinka AI"},"offers":{"@type":"Offer","url":"https://www.trinka.ai/pricing","priceCurrency":"USD","price":"0","priceValidUntil":"2030-12-31","availability":"InStock","hasMerchantReturnPolicy":{"@type":"MerchantReturnPolicy","url":"https://www.trinka.ai/termsofservices","returnPolicyCategory":"https://schema.org/MerchantReturnNotPermitted","applicableCountry":"GL"},"shippingDetails":{"@type":"OfferShippingDetails","shippingDestination":{"@type":"DefinedRegion","addressCountry":"ALL"},"shippingRate":{"@type":"MonetaryAmount","value":"0","currency":"USD"},"deliveryTime":{"@type":"ShippingDeliveryTime","handlingTime":{"@type":"QuantitativeValue","minValue":1,"maxValue":1,"unitCode":"d"},"transitTime":{"@type":"QuantitativeValue","minValue":1,"maxValue":1,"unitCode":"d"}}}},"aggregateRating":{"@type":"AggregateRating","ratingValue":"4.8","reviewCount":"189"},"review":{"@type":"Review","author":{"@type":"Person","name":"Abba Kasim"},"reviewRating":{"@type":"Rating","ratingValue":"5","bestRating":"5"},"reviewBody":"The Trinka platform is intuitive and easy to navigate. Most importantly, the plagiarism checker is a game-changer! It gives me confidence that my work is original and free from unintentional copying, which is crucial for academic integrity."}},{"@type":"FAQPage","mainEntity":[{"@type":"Question","name":"How does Trinka's Plagiarism Check work?","acceptedAnswer":{"@type":"Answer","text":"That’s easy! Go to your Trinka Cloud Account (haven’t signed up for a free account yet? Sign up now!). Navigate to the Plagiarism Check page by clicking on it from the right panel. Upload a document and select the check that works for you. You can choose a file you have already uploaded on Trinka Drive, too. Get the detailed report in minutes!"}},{"@type":"Question","name":"How is Trinka’s Plagiarism Check different from others?","acceptedAnswer":{"@type":"Answer","text":"Unlike other tools, Trinka lets you choose a plagiarism check that meets your needs – Internet content or Internet + paid publications. Our technology offers superior detection technology that is trusted by large academic publishers worldwide."}}]},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Trinka AI","item":"https://www.trinka.ai"},{"@type":"ListItem","position":2,"name":"Plagiarism Checker","item":"https://www.trinka.ai/features/plagiarism-check"}]}]}
    `;
    this._renderer2.appendChild(this._document.head, script);

    //ire('identify', { 'customerId': '', customerEmail: '', customProfileId: '' });
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      $('#closedPopup, #wordPluginPopup').click(function () {
        $('iframe.youtubeVideoForTryDemo').remove()
      });

      $('#VewiVideoSection').click(function () {
        if (!$('#iframe').length) {
          $('#iframeHolder').html('<iframe class="youtubeVideoForTryDemo" id="iframe" src="https://www.youtube.com/embed/Mc_EZXIzvFU" width="100%" height="450"></iframe>');
        }
      });

    }
  }
  ngOnDestroy() {
    this.document.body.classList.remove('nosnipptFooter');
  }
  playPause() {
    var myVideo: any = document.getElementById("myVideo");
    if (myVideo.paused) myVideo.play();
    else myVideo.pause();
    this.video_pause= !this.video_pause;  
  }
  showTab = 1;
  advancePlagiarism(index) {
    this.showTab = index;
  }

  standardshowTab = 2;
  standardPlagiarism(index) {
    this.standardshowTab = index;
  }

  freeshowTab = 1;
  freeScore(index) {
    this.freeshowTab = index;
  }

  activateTab(panelId: string) {
    document.querySelectorAll('[role="tabpanel"]').forEach(panel => {
      panel.setAttribute('tabindex', '-1');
    });
  
    const activePanel = document.getElementById(panelId);
    if (activePanel) {
      activePanel.setAttribute('tabindex', '0');
      activePanel.focus();
    }
  }

  buildPlanCheckoutUrl(
    planType: string,
    opts: {
      coupon?: string;
      utm_source?: string;
      utm_medium?: string;
      utm_campaign?: string;
      utm_id?: string;
    } = {}
  ) {
    const {
      coupon,
      utm_source,
      utm_medium,
      utm_campaign,
      utm_id
    } = opts;
  
    const payload = {
      frmktg: true,
      go_to_payments: true,
      plan_type: planType,
      planType: planType,
      plan_name: 'basic'
    };
  
    const encoded = btoa(
      encodeURIComponent(JSON.stringify(payload))
    ).replace(/=/g, '');
  
    const params = new URLSearchParams();
  
    if (coupon) params.set('cp', coupon);
    if (utm_source) params.set('utm_source', utm_source);
    if (utm_medium) params.set('utm_medium', utm_medium);
    if (utm_campaign) params.set('utm_campaign', utm_campaign);
    if (utm_id) params.set('utm_id', utm_id);
  
    const query = params.toString();
  
    return `${environment.paymentsUrl}/user/${encoded}${query ? `?${query}` : ''}`;
  }
}
